import { createContext, useContext, useEffect } from 'react';

/**
 * Lets a page put a human name in the breadcrumb the shell derives from the
 * URL. The shell knows `/users/42/edit` is "Users › User 42 › Edit"; only the
 * page knows user 42 is `mark02671`.
 *
 *   useCrumbLabel(user?.username);   // in UserDetail / EditUser / UserLogs
 *
 * Cleared on unmount, so a label can never outlive the page that set it.
 */
export const CrumbContext = createContext(() => {});

export function useCrumbLabel(label) {
  const set = useContext(CrumbContext);
  useEffect(() => {
    if (label) set(label);
    return () => set(null);
  }, [label, set]);
}
